import React from 'react';
import { useApp } from '../context/AppContext';
import { useDisplayTimezone } from '../context/TimeModeContext';
import { DAY_ANCHOR_TZ } from '../utils/time';
import useTeamRows from '../hooks/useTeamRows';
import TeamGrid from '../components/TeamGrid';
import TodayBadge from '../components/TodayBadge';
import Layout from '../components/Layout';

// Lighter version of the Admin dashboard for VAs — just who's checked in or
// out, no summary counts and no remarks/notes.
export default function TeamStatus() {
  const { currentUser } = useApp();
  const displayTz = useDisplayTimezone(currentUser);
  // Admins don't check in/out as part of the VA roster this page is meant
  // to show — filtered here rather than in the shared hook, since the Admin
  // Dashboard (which reuses the same hook) still needs to see everyone.
  const teamRows = useTeamRows().filter((row) => !row.user.isAdmin);

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 py-6 sm:py-10">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div>
            <h1 className="text-lg sm:text-xl font-semibold text-ink">Team</h1>
            <p className="text-xs sm:text-sm text-muted mt-1">Who's checked in right now.</p>
          </div>
          <TodayBadge timezone={DAY_ANCHOR_TZ} />
        </div>

        <div className="mt-6">
          <TeamGrid teamRows={teamRows} showNotes={false} showLastAction={false} displayTimezone={displayTz} />
        </div>
      </div>
    </Layout>
  );
}
